import React, { useState } from "react";
import axios from "axios";
import { useForm, useFormState } from "react-hook-form";
import { IoTicketOutline } from "react-icons/io5";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import MyCountdown from "../parts/countdown";

export default function Form() {

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, isSubmitSuccessful, isSubmitted , isSubmitting}
    } = useForm();

    const [preloader, preloaderFormStyle] = useState('hidden');
    const [promoAlert, setPromoAlertData] = useState('');
    const [promoAlertStyle, setPromoAlerStyle] = useState('');

    const [event, setEvent] = useState({});

    const clearDataPromo = async (data) => {

        var promocodeData = {
            promocode: data,
            site_name : domain,
            action: 'checkpromo'
        }
        try {
            const response = await axios.post(
                'https://ekonomika.ua/wp-content/plugins/ekonomika-mrkntg/ekonomika-requests.php',
                promocodeData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            if (response.status === 201 || response.status === 200) {
                if(response.data.check === false) {
                    setPromoAlertData(response.data.message);
                    setPromoAlerStyle(errorStyle);
                } else {
                    setPromoAlertData(FaCheck);
                    setPromoAlerStyle(successStyle);
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const onSubmit = async (data) => {

        try {

            preloaderFormStyle('flex');

            const response = await axios.post(
                'https://ekonomika.ua/wp-content/plugins/ekonomika-mrkntg/ekonomika-requests.php',
                data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

            // Check if response is successful
            if(response.data.check !== false) {
                if (response.status === 201) {
                    //console.log(response.data);
                    window.location.href = response.data;
                } else {
                    //console.log(response.data);
                    window.location.href = response.data;
                }
            }

        } catch (error) {
            console.error('Error:', error);
        } finally {
            preloaderFormStyle('hidden');
        }
    };

    const normalizeTel = (value) => {
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d)/g, "($1) $2");
        if(value.length < 14) {
            value = value.replace(/(\d{3})(\d{2})(\d{2})$/, "$1-$2-$3");
        } else {
            value = value.replace(/(\d{3})(\d{2})(\d{2})(\d{2})$/, "$1-$2-$3-$4");
        }
        return value;
    };

    const errorStyle = "absolute top-0 right-0 text-red-800 z-10 bg-white text-sm h-full w-[80px] p-[4px] leading-none rounded-r flex items-center items-center";
    const successStyle = "absolute top-0 right-0 text-[#003366] z-10 text-sm h-full h-full p-[4px] leading-none rounded-full flex items-center items-center";
    const domain =   window.location.protocol + '//' + window.location.host;

    //get url parameters
    const windowUrl = window.location.search;
    const searchParams = new URLSearchParams(windowUrl);

    const utm_source = searchParams.get("utm_source") ? searchParams.get("utm_source") : '';
    const utm_medium = searchParams.get("utm_medium") ? searchParams.get("utm_medium") : '';
    const utm_campaign = searchParams.get("utm_campaign") ? searchParams.get("utm_campaign") : '';

    return (
        <div>

            <div className="flex flex-wrap items-center mb-4">
                <div className="w-[40px] h-[40px] flex items-center rounded-full mr-[20px]">
                    <IoTicketOutline className="text-4xl text-[#8f78be]"/>
                </div>
                <div className="grid grid-cols-2 w-[calc(100%-70px)] max-w-[270px]">
                    <div className="text-2xl mr-4 font-bold">6500 <span>грн</span></div>
                    <div className="text-2xl opacity-50 line-through">8000 <span>грн</span></div>
                    <p className="text-sm text-gray-500 font-light col-span-2">* Ціна до оподаткування</p>
                </div>
            </div>

            <div className="countdown mb-4">
                {/*<MyCountdown/>*/}
                <p>Івент розпочався!</p>
            </div>

            <p>Заповніть форму і отримайте спеціальну ранню пропозицію</p>

            <form onSubmit={handleSubmit(onSubmit)} className="mt-4 relative">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="w-full mb-4 relative">
                        <input type="email" name="email" {...register("email", {required: true})} placeholder="Пошта"
                               className="bg-transparent appearance-none border-b border-b-stone-700 placeholder-zinc-700 w-full py-2 px-4 text-neutral-800 focus:placeholder-neutral-800 leading-tight focus:outline-none focus:bg-transparent focus:border-black"/>
                        {errors.email && <div className={errorStyle}>вкажіть email</div>}
                    </div>
                    <div className="w-full mb-4 relative">
                        <input
                            type="text"
                            {...register("phone", {
                                required: true,
                                pattern: /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}-[0-9]{0,5}/ && /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}/
                            })}
                            maxLength="17"
                            placeholder="Тел. (099) 999-99-99"
                            onChange={(event) => {
                                const {value} = event.target;
                                event.target.value = normalizeTel(value);
                            }}
                            name="phone"
                            className={"bg-transparent appearance-none border-b border-b-stone-700 placeholder-zinc-700 w-full py-2 px-4 text-neutral-800 focus:placeholder-neutral-800 leading-tight focus:outline-none focus:bg-transparent focus:border-black " + (errors.phone ? "form-control text-amber-700" : "form-control")}/>
                        {errors.phone && errors.phone.type === "required" && (
                            <div className={errorStyle}>вкажіть телефон</div>
                        )}
                        {errors.phone && errors.phone.type === "pattern" && (
                            <div className={errorStyle}>вкажіть телефон</div>
                        )}
                    </div>
                </div>

                <input name="event_name" {...register("event_name")} type="hidden" value="67ff65c9e9e0212822c63cf1"/>
                <input name="site_name" {...register("site_name")} type="hidden" value={domain}/>
                <input name="price" {...register("price")} type="hidden" value="6500"/>
                <input name="position" {...register("position")} type="hidden" value=""/>
                <input name="utm_source" {...register("utm_source")} type="hidden" value={utm_source}/>
                <input name="utm_medium" {...register("utm_medium")} type="hidden" value={utm_medium}/>
                <input name="utm_campaign" {...register("utm_campaign")} type="hidden" value={utm_campaign}/>
                <div className="grid grid-cols-2 gap-2 justify-start align-end relative">

                    <div className="relative rounded overflow-hidden h-max">
                        <input
                            type="text"
                            {...register("promocode")}
                            name="promocode"
                            placeholder="Промокод"
                            onBlur={(event) => {
                                const {value} = event.target;
                                clearDataPromo(value);
                            }}
                            className={"bg-transparent appearance-none border-b border-b-stone-700 placeholder-zinc-700 w-full py-2 px-4 text-neutral-800 focus:placeholder-neutral-800 leading-tight focus:outline-none focus:bg-transparent focus:border-black " + (errors.phone ? "form-control text-amber-700" : "form-control")}/>
                        {promoAlert ? <div className={promoAlertStyle}>{promoAlert}</div> : null}

                    </div>

                    <input type="submit" name="submit" value="Надіслати"
                           className="bg-[#ff8048] hover:bg-[#fe5b14] w-full text-black hover:text-black font-normal uppercase py-2 px-4 inline-flex items-center border-b-4 border-[#8f78be] cursor-pointer"/>

                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSdwh5YjR0HoD07bbcJmMcS_TCoTnuT3rUX4ZD778JEo6xEPDw/viewform?usp=header" target="_blank"
                       className="text-sm text-gray-400 hover:text-gray-700 w-full font-normal py-2 px-4 inline-flex items-center border-gray-400 cursor-pointer max-sm:col-span-2">Корпоративним клієнтам</a>

                </div>
                <div
                    className={"absolute top-0 left-0 w-full h-full d-flex items-center justify-center bg-white/90 text-[#8f78be] " + preloader}>
                    <div className="flex text-2xl justify-center items-center">
                        <FaRegCheckCircle className="mr-3"/> <span>Зачекайте...</span>
                    </div>
                </div>
            </form>

        </div>

    )
}